import { App } from 'vue'
import RadioGroup from './LpRadioGroup.vue'

RadioGroup.install = (Vue: App) => {
  Vue.component(RadioGroup.name, RadioGroup)
}

export default RadioGroup
